// The error vocabulary of core.md §14, one key per code.
export const errors = {
  // ── errors ───────────────────────────────────────────────────────────
  'errors.generic': 'خطای غیرمنتظره‌ای رخ داد.',
  'errors.loadFailed': 'بارگذاری نشد.',
  'errors.saveFailed': 'ذخیره نشد.',
  'errors.deleteFailed': 'حذف نشد.',
  'errors.invalidInput': 'بخشی از مقادیر واردشده معتبر نیست.',
  'errors.insufficientCredits': 'پارسهٔ کافی برای این عملیات ندارید.',
  'errors.unavailable': 'سرویس در دسترس نیست.',
  'errors.unavailableBody': 'سرور پاسخ نداد. چیزی از دست نرفته است؛ کمی بعد دوباره تلاش کنید.',
  'errors.notFound': 'پیدا نشد.',
  'errors.encounterClosed': 'این ویزیت بسته شده است. برای تغییر، آن را بازگشایی کنید.',
  'errors.anotherEncounterOpen': 'ویزیت دیگری برای این بیمار باز است.',
  'errors.caseArchived': 'این بیمار بایگانی شده است. برای شروع ویزیت، از بایگانی خارجش کنید.',
  'errors.threadNotFound': 'این گفتگو دیگر وجود ندارد.',
  'errors.queryTooComplex': 'درخواست بیش از حد بزرگ بود. صفحه را دوباره باز کنید.',
  'errors.offline': 'آفلاین هستید.',
};

export default errors;
